<!--
 * @Description: 基本资料
 * @Autor: lwq
 * @Date: 2020-07-16 09:58:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 13:54:43
 * @FilePath: \mrc-base-server-view\src\views\mrc_system_admin\modules\baseInfo.vue
-->
<template>
  <v-card class="pa-0"
          :elevation="0">
    <v-card-text>
      <v-row>
        <v-col cols="12"
               sm="3"
               v-if="params.uuid">
          <mrc_ess_switch :true-value="1"
                          :false-value="0"
                          v-model="params.status"
                          :readonly="disabled"
                          :label="
              params.status ? $t('label_To_enable_the') : $t('label_disable')
            "></mrc_ess_switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_account') + '*'"
                             style="width:100%"
                             :error-messages="
              $errors(
                'params',
                'user_account',
                requiredRule.concat(maxLength(20))
              )
            "
                             :readonly="disabled"
                             :disabled="Boolean(params.uuid)"
                             v-model.trim="params.user_account"
                             :isNational="judegNational('user_account')"
                             :placeholder="$t('label_account')"></mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               class="d-flex flex-column "
               sm="6">
          <!-- :readonly="Boolean(params.uuid)" -->
          <mrc_ess_input :label="$t('label_password') + '*'"
                         type="password"
                         @input="$v.params.user_pwd.$touch()"
                         @blur="$v.params.user_pwd.$touch()"
                         v-model.trim="params.user_pwd"
                         :placeholder="$t('label_password')"
                         :readonly="disabled"
                         :disabled="Boolean(params.uuid)"
                         :error-messages="$errors('params', 'user_pwd', requiredRule)"></mrc_ess_input>
          <span v-if="params.uuid"
                @click="resetPassword"
                class="mt-n4"
                :style="{
              color: $vuetify.theme.defaults.light.primary,
              position: 'relative',
              cursor: 'pointer',
            }">{{ $t('label_To_reset_your_password') }}</span>
          <!-- <span v-if="params.uuid"
                @click="resetPassword"
                :style="{
              color: $vuetify.theme.defaults.light.primary,
              position: 'relative',
              top: '10px',
              cursor: 'pointer',
            }">{{ $t('label_To_reset_your_password') }}</span> -->
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_The_name') + '*'"
                             style="width:100%"
                             :error-messages="
              $errors('params', 'user_name', requiredRule.concat(maxLength(20)))
            "
                             v-model.trim="params.user_name"
                             :isNational="judegNational('user_name')"
                             :readonly="disabled"
                             :placeholder="$t('label_The_name')"></mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_Personal_mailbox') + '*'"
                             style="width:100%"
                             :error-messages="
              $errors(
                'params',
                'user_primary_email',
                requiredRule.concat(emailRule)
              )
            "
                             v-model.trim="params.user_primary_email"
                             :isNational="judegNational('user_primary_email')"
                             :readonly="disabled"
                             :placeholder="$t('label_Personal_mailbox')"></mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               sm="12">
          <!-- <mrc_ess_input :label="$t('label_Responsible_for_the_customer')" value='MRC' readonly></mrc_ess_input> -->
          <!-- <mrc_ess_prompt
            obj="mrbase_sys_clients"
            :label="$t('label_Responsible_for_the_customer')"
            multiple
            :disabled="disabled"
            v-model="computed_clients_uuid"
          >
          </mrc_ess_prompt> -->

          <mrc_ess_autoComplete :label="$t('label_Responsible_for_the_customer')"
                                clientView
                                multiple
                                :readonly="disabled"
                                v-model="params.clients_uuid"
                                prompt_name="mrbase_sys_clients">
          </mrc_ess_autoComplete>
          <!-- :errMsg="$errors('params','clients_uuid',requiredRule)" -->
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn @cancel="cancel"
                       v-if="!disabled"
                       :loading="loading"
                       @success="success"
                       :cancelText="cancelText || $t('label_cancel')"
                       :successText="successText || $t('label_submit')"></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { required, email, maxLength } from 'vuelidate/lib/validators'
import { mrc_admin_reset } from '@/service/api/mrc_system_admin'

export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
    paramsData: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      params: {
        status: 1,
        user_account: '',
        user_pwd: '',
        user_primary_email: '',
        clients_uuid: '',
        user_name: '',
        uuid: '',
      },
    }
  },
  validations: {
    params: {
      user_account: {
        required,
        maxLength: maxLength(20),
      },
      user_pwd: {
        required,
      },
      user_name: {
        required,
        maxLength: maxLength(20),
      },
      user_primary_email: {
        required,
        email,
      },
      // clients_uuid: {
      //   required
      // }
    },
  },
  computed: {
    computed_clients_uuid: {
      get () {
        if (this.params.clients_uuid) {
          return this.params.clients_uuid.indexOf(',') > -1
            ? this.params.clients_uuid.split(',')
            : [this.params.clients_uuid]
        } else {
          return []
        }
      },
      set (val) {
        this.params.clients_uuid = val.join()
      },
    },
  },
  created () { },
  watch: {
    paramsData: {
      handler (val) {
        this.params = val
      },
      deep: true,
    },
  },
  async created () {
    await this.national('mrbase_sys_users')
    if (this.paramsData) {
      this.params = this.paramsData
    }
  },

  methods: {
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit('success', this.params)
    },
    cancel () {
      this.$emit('cancel')
    },
    resetPassword () {
      this.$myConfirm({
        content: this.$t('message_Confirm_that_the_password_is_reset'),
      })
        .then(async () => {
          const reset = await mrc_admin_reset({
            uuid: this.params.uuid,
            login_url: this.$store.state.loginUrl,
          })
          if (reset.code == 200) {
            this.$Message({
              text: this.$t('message_The_operation_was_successful'),
            })
          }
        })
        .catch(() => { })
    },
  },
}
</script>

<style scoped></style>
